export default __webpack_public_path__ + "static/blob-27-2d17aa21f5faf1d0f976a05ec4a1285d.svg";